// Vykreslení Markdownu (UI kit ho nemá). GFM kvůli tabulkám; HTML ze vstupu se nevykresluje.
// Odkazy do přepisu schůzky `[2026-10-12 10:32, 00:54:29]` se vykreslí jako tlačítko, které otevře panel přepisu.
import { memo, useMemo } from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { formatTimecode, linkTranscriptRefs, parseTranscriptHref } from '@sam/shared';
import { openTranscript } from '../lib/transcript';

const fmtStart = (start: string) => {
  const [d, t] = start.split('T');
  const [, m, day] = d.split('-').map(Number);
  return `${day}. ${m}. ${t}`;
};

function makeComponents(verified: Set<string> | undefined): Components {
  return {
    a: ({ href, children }) => {
      const ref = parseTranscriptHref(href);
      if (ref) {
        // Klikací jen přepis, který agent v této odpovědi opravdu načetl přes bránu; jinak neověřená citace bez odkazu.
        if (!verified?.has(ref.start)) {
          const why = `Neověřená citace (${fmtStart(ref.start)}, ${formatTimecode(ref.t)}): Sam tento přepis v odpovědi nenačetl přes bránu, odkaz nejde ověřit.`;
          return (
            <span className="ts-ref unverified" title={why} aria-label={why}>
              {children}
            </span>
          );
        }
        const label = `Otevřít přepis schůzky ${fmtStart(ref.start)} v čase ${formatTimecode(ref.t)}`;
        return (
          <button type="button" className="ts-ref" onClick={() => openTranscript(ref)} title={label} aria-label={label}>
            {children}
          </button>
        );
      }
      return (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      );
    },
    table: ({ children }) => (
      <div className="md-table">
        <table>{children}</table>
      </div>
    ),
  };
}

/** `verified` = začátky přepisů, které agent v tahu načetl přes bránu (verifiedTranscripts ze zdrojů zprávy). */
export const Markdown = memo(function Markdown({ text, verified }: { text: string; verified?: Set<string> }) {
  const md = useMemo(() => linkTranscriptRefs(text), [text]);
  const components = useMemo(() => makeComponents(verified), [verified]);
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={components} skipHtml>
        {md}
      </ReactMarkdown>
    </div>
  );
});
